import { render } from "./UsoMutuoComponent.vue?vue&type=template&id=6ac07b5d"
import script from "./UsoMutuoComponent.vue?vue&type=script&lang=js"
export * from "./UsoMutuoComponent.vue?vue&type=script&lang=js"

import "./UsoMutuoComponent.vue?vue&type=style&index=0&id=6ac07b5d&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__